import { Observable } from 'rxjs';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';
import { ServiceModel } from '../../models/configuration/service.model';

export class GetServiceUseCase
  implements UseCase<{ idTipoServicio: string }, ServiceModel>
{
  constructor(private configRepository: ConfigurationRepository) {}
  execute(params: { idTipoServicio: string }): Observable<ServiceModel> {
    return this.configRepository.getService(params);
  }
}
